import { render, staticRenderFns } from "./ReviewAndPrint.vue?vue&type=template&id=c2a414c0"
import script from "./ReviewAndPrint.vue?vue&type=script&lang=ts"
export * from "./ReviewAndPrint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports